import React from 'react';
import PropTypes from 'prop-types';

export default function FavoriteDesignerIndicatorIcon(props, context) {
    const id = props.isFavorite ? 'unset_favorite_designer' : 'set_favorite_designer';
    return (
        <span
            className="user-details__icon--favorite"
            data-is-favorite={props.isFavorite}
            title={context.intl.formatMessage({
                id,
            }, {
                displayName: props.designer.name,
            },
            )}
        />
    );
}

FavoriteDesignerIndicatorIcon.contextTypes = {
    intl: PropTypes.object,
};

FavoriteDesignerIndicatorIcon.propTypes = {
    isFavorite: PropTypes.bool.isRequired,
    designer: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/favorite-designer/FavoriteDesignerIndicatorIcon.jsx